import type { NavIconKey } from './navConfig.js'
import { cfIconSvgProps } from '@utils/iconSvg.js'

export function NavIcon({ icon, size = 22 }: { icon: NavIconKey; size?: number }) {
  const p = cfIconSvgProps(size)
  switch (icon) {
    case 'inicio':
      return (
        <svg {...p}>
          <path d='M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1z' />
        </svg>
      )
    case 'jornada':
      return (
        <svg {...p}>
          <path d='M8 3v18' />
          <circle cx='8' cy='7' r='2' />
          <circle cx='8' cy='13' r='2' />
          <circle cx='8' cy='19' r='2' />
          <path d='M11 7h7M11 13h5M11 19h3' />
        </svg>
      )
    case 'etapa':
      return (
        <svg {...p}>
          <circle cx='12' cy='12' r='9' />
          <path d='M12 8v4l3 2' />
        </svg>
      )
    case 'checklist':
      return (
        <svg {...p}>
          <rect x='8' y='2' width='8' height='4' rx='1' />
          <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
          <path d='M9 12l2 2 4-4' />
        </svg>
      )
    case 'ferramenta':
      return (
        <svg {...p}>
          <rect x='6' y='2' width='12' height='20' rx='2' />
          <path d='M9 7h6M9 11h6' />
          <circle cx='12' cy='17' r='1.5' />
        </svg>
      )
    case 'wiki':
      return (
        <svg {...p}>
          <path d='M4 19.5A2.5 2.5 0 0 1 6.5 17H20' />
          <path d='M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' />
        </svg>
      )
    case 'obra':
      return (
        <svg {...p}>
          <path d='M3 9.5L12 2l9 7.5' />
          <path d='M5 9v11a1 1 0 0 0 1 1h3v-7h6v7h3a1 1 0 0 0 1-1V9' />
        </svg>
      )
    case 'financeiro':
      return (
        <svg {...p}>
          <path d='M20 12V8H6a2 2 0 0 1 0-4h12v4' />
          <path d='M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6' />
          <circle cx='16' cy='14' r='1.5' />
        </svg>
      )
    case 'materiais':
      return (
        <svg {...p}>
          <path d='M12 2l8 4v12l-8 4-8-4V6z' />
          <path d='M4 6l8 4 8-4' />
          <path d='M12 10v12' />
        </svg>
      )
    case 'documentos':
      return (
        <svg {...p}>
          <path d='M3 7a2 2 0 0 1 2-2h4l2 3h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' />
        </svg>
      )
    case 'diario':
      return (
        <svg {...p}>
          <path d='M12 20h9' />
          <path d='M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z' />
        </svg>
      )
    case 'pendencias':
      return (
        <svg {...p}>
          <path d='M9 11l3 3L22 4' />
          <path d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' />
        </svg>
      )
    case 'alertas':
      return (
        <svg {...p}>
          <path d='M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9' />
          <path d='M10.3 21a2 2 0 0 0 3.4 0' />
        </svg>
      )
    case 'config':
      return (
        <svg {...p}>
          <circle cx='12' cy='12' r='3' />
          <path d='M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42' />
        </svg>
      )
    case 'contratos':
      return (
        <svg {...p}>
          <path d='M6 3h9l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z' />
          <path d='M15 3v4h4' />
          <path d='M8 13h8M8 17h5' />
          <path d='M9 9.5l1.5 1.5L13 8.5' />
        </svg>
      )
    case 'contatos':
      return (
        <svg {...p}>
          <circle cx='9' cy='8' r='3.5' />
          <path d='M2.5 20a6.5 6.5 0 0 1 13 0' />
          <path d='M16 4.5a3.5 3.5 0 0 1 0 7' />
          <path d='M17.5 14.5a6.5 6.5 0 0 1 4 5.5' />
        </svg>
      )
    case 'cronograma':
      return (
        <svg {...p}>
          <rect x='3' y='5' width='18' height='16' rx='2' />
          <path d='M3 10h18M8 3v4M16 3v4' />
          <path d='M7 14h4M13 17h4' />
        </svg>
      )
    case 'decisoes':
      return (
        <svg {...p}>
          <path d='M8 3h8l1 3h3v15H4V6h3z' />
          <path d='M9 13l2 2 4-4' />
        </svg>
      )
    case 'camera':
      return (
        <svg {...p}>
          <path d='M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z' />
          <circle cx='12' cy='13.5' r='3.5' />
        </svg>
      )
  }
}
